import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Progress } from "@/components/ui/progress"
import { Loader2 } from "lucide-react"

interface ImportProgressProps {
  totalUsers: number
}

export function ImportProgress({ totalUsers }: ImportProgressProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Processing Import</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex justify-center">
          <Loader2 className="h-12 w-12 animate-spin text-primary" />
        </div>

        <div className="text-center space-y-2">
          <p className="text-lg font-medium">
            Importing {totalUsers} user{totalUsers !== 1 ? 's' : ''}...
          </p>
          <p className="text-sm text-muted-foreground">
            This may take a few moments. Please don't close this page.
          </p>
        </div>

        <Progress className="w-full" />
      </CardContent>
    </Card>
  )
}
